var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLetterFastThin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 161,
  height: 148
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "letter-fast-thin_svg__a",
  d: "M0 0h18.51v10.938H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "letter-fast-thin_svg__c",
  d: "M0 0h111.7v100H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#DF0000",
  d: "M15.443 67.975q.35.176.784.189l16.7.062a1.774 1.774 0 0 0 1.773-1.75 1.773 1.773 0 0 0-1.75-1.774l-16.718-.071a1.773 1.773 0 0 0-1.774 1.75 1.76 1.76 0 0 0 .985 1.594"
}), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(26.5 -139.769 58.054)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "letter-fast-thin_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#letter-fast-thin_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#DF0000",
  d: "M18.334.983a1.773 1.773 0 0 0-2.358-.806L1.003 7.573C.116 8.016-.247 9.084.176 9.95c.303.625.927.987 1.593.987q.392 0 .785-.181L17.528 3.36a1.797 1.797 0 0 0 .806-2.378z",
  mask: "url(#letter-fast-thin_svg__b)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#DF0000",
  d: "m32.858 86.882-16.7-.063a1.773 1.773 0 0 0-1.774 1.75c-.008.695.39 1.298.985 1.595q.352.176.784.188l16.7.062a1.773 1.773 0 0 0 1.774-1.75 1.785 1.785 0 0 0-1.769-1.782"
}), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(26.5 12.887 131.597)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "letter-fast-thin_svg__d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#letter-fast-thin_svg__c"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#DF0000",
  d: "M34.285 95.99a4.8 4.8 0 0 1-.886.342l11.688-29.846a1.75 1.75 0 0 0-1.007-2.277c-.907-.342-1.935.101-2.278 1.008l-11.99 30.652a4.73 4.73 0 0 1-2.016-2.056L6.294 50.283l49.373 12.052c.706.161 1.39.262 2.076.262a8.76 8.76 0 0 0 8-5.22l20.455-46.552 21.483 43.51c.362.705.524 1.49.483 2.277l-31.478-9.069c-.947-.262-1.914.262-2.176 1.21-.262.946.262 1.914 1.209 2.176l31.055 8.947c-.383.383-.806.726-1.29.968zM3.795 41.98a4.92 4.92 0 0 1 2.438-2.801L77.432 4.014a4.75 4.75 0 0 1 3.708-.242 4.92 4.92 0 0 1 2.801 2.438l.222.464-21.644 49.273a5.194 5.194 0 0 1-6.005 2.962L4.258 46.153l-.221-.464a4.75 4.75 0 0 1-.242-3.708zm107.05 10.782L87.69 5.888l-.585-1.21C85.049.529 80.032-1.185 75.88.87L4.681 36.036A8.32 8.32 0 0 0 .45 40.853a8.28 8.28 0 0 0 .424 6.388l.584 1.209 23.155 46.895c1.149 2.317 3.265 3.93 5.824 4.474a8.6 8.6 0 0 0 1.754.181c1.27 0 2.498-.282 3.647-.847l71.199-35.165c1.894-.928 3.345-2.56 4.111-4.555.826-2.197.726-4.575-.302-6.67z",
  mask: "url(#letter-fast-thin_svg__d)"
})))));
export default SvgLetterFastThin;